module.exports = __webpack_public_path__ + "img/certificate6.4e732ef7.jpg";